import { render, staticRenderFns } from "./AddCompany.vue?vue&type=template&id=b829b252&"
import script from "./AddCompany.vue?vue&type=script&lang=js&"
export * from "./AddCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports